import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { ItineraryItem } from '../types/Quotation';

export function useItinerary(nights: number): [ItineraryItem[], Dispatch<SetStateAction<ItineraryItem[]>>] {
  const [itinerary, setItinerary] = useState<ItineraryItem[]>([]);

  useEffect(() => {
    setItinerary((prev) => {
      const targetLen = Math.max(0, nights) + 1;
      const next: ItineraryItem[] = [];
      for (let i = 0; i < targetLen; i++) {
        const existing = prev[i];
        if (existing) {
          next.push({ ...existing, day: i + 1 });
          continue;
        }
        next.push({
          day: i + 1,
          title: '',
          place: { label: '', value: '', nights: 1 },
          flights: [],
          activities: [],
          hotels: [],
          transfers: []
        });
      }
      return next;
    });
  }, [nights]);

  return [itinerary, setItinerary];
}
